var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Block',{attrs:{"theme":_vm.theme,"title":"职能科室分类"}},[_c('chart-bar',{staticClass:"chart",attrs:{"colors":_vm.colors,"types":_vm.types,"dataList":_vm.dataList},on:{"clickBar":_vm.clickBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }